import styles from "./Main.module.css"

const Main = (props: { children: React.ReactNode }) => {
  return <div className={[styles.container, "d-flex flex-column"].join(" ")}>
    {props.children}
  </div>
}

export default Main